import clsx from 'clsx';
import emblem from '../assets/brandfieldcrew-emblem.png';
import lockup from '../assets/brandfieldcrew-lockup.png';

interface BrandLogoProps {
  className?: string;
  decorative?: boolean;
  variant?: 'emblem' | 'lockup';
}

export function BrandLogo({ className, decorative = false, variant = 'emblem' }: BrandLogoProps) {
  return (
    <img
      alt={decorative ? '' : 'Brand Field Crew'}
      className={clsx('brand-logo', `brand-logo-${variant}`, className)}
      src={variant === 'lockup' ? lockup : emblem}
    />
  );
}
